module.exports = __webpack_public_path__ + "static/img/dzbl.a5a580c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dzbl.png
// module id = ITkt
// module chunks = 1